<form [formGroup]="addOrderMedicineForm">
    <ng-template matStepLabel>Select Medicine</ng-template>
    <div class="row mt-4">
        <div class="col-md-6">

            <p>
                <mat-form-field appearance="outline">
                    <mat-label>Search for medicine</mat-label>
                    <input required [disabled]="isLoading" data-testid="add-medicine-name" type="text"
                        placeholder="Search for medicine" aria-label="Search for medicine" matInput
                        formControlName="medicineFilter" [matAutocomplete]="auto">
                    <mat-autocomplete data-testid="add-medicine-autocompletion-list"
                        (optionSelected)="medicineSelected($event)" autoActiveFirstOption #auto="matAutocomplete">
                        <mat-option *ngFor="let med of medicine" [value]="med">
                            {{med.name}}
                        </mat-option>
                    </mat-autocomplete>
                    <mat-icon matPrefix>search</mat-icon>
                    <mat-error *ngIf="addOrderMedicineForm.get('medicineFilter')?.invalid">
                        Medicine is invalid
                    </mat-error>
                </mat-form-field>
            </p>


            <p>
                <mat-form-field appearance="outline">
                    <mat-label>Select package type</mat-label>
                    <mat-select (selectionChange)="packageTypeSelected($event)" required
                        data-testid="add-medicine-package-type" formControlName="packageType">
                        <mat-option *ngFor="let type of medicineDosageTypePackageTypes" [value]="type">
                            {{type.package_type.type}} ({{type.contained_quantity}})
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </p>

        </div>
        <div class="col-md-6">

            <p>
                <mat-form-field appearance="outline">
                    <mat-label>Select dosage type</mat-label>
                    <mat-select required data-testid="add-medicine-dosage-type"
                        [disabled]="isLoading || (dosageTypes.length === 0)" formControlName="dosageType"
                        (selectionChange)="getMedicineDosagePackageTypes($event)">
                        <mat-option [disabled]="type.is_active === 0" *ngFor="let type of dosageTypes" [value]="type">
                            {{type.additional_information}}
                        </mat-option>
                    </mat-select>
                    <mat-error *ngIf="addOrderMedicineForm.get('dosageType')?.invalid">
                        Dosage type is invalid
                    </mat-error>
                </mat-form-field>
            </p>

        </div>
    </div>
    <p>
        <button [disabled]="addOrderMedicineForm.invalid || isLoading || !selectedDosageType" data-testid="add-medicine-add-button" type="button"
            (click)="addOrderItem()" class="mx-1" mat-stroked-button>
            <mat-icon>add</mat-icon> Add
        </button>
    </p>
</form>